import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../language/keys';
import { convertMonthToFloatYears } from '../utils';

/**
 * return method that recive value in months and returns 
 * @return (value:number | undefined) => string  '1.5 Years' | '2 Months'
 */
export const useFormattedYears = (): (value:number) => string => {
  const { t: translate } = useTranslation();

  return (value: number) => {
    if (value && value > 12) {
      return translate(STRING_KEYS.INDUSTRY_YEARS, {
        value: convertMonthToFloatYears(value),
      });
    }

    if (value && value === 12) {
      return translate(STRING_KEYS.INDUSTRY_YEAR, {
        value: convertMonthToFloatYears(value),
      });
    }
     
    if (value && value === 1) {
      return translate(STRING_KEYS.INDUSTRY_MONTH, { value });
    }
    
    return translate(STRING_KEYS.INDUSTRY_MONTHS, { value });
  };
};
